import React, { ErrorInfo } from 'react'
import { getLogger } from '../../../../services/logger/logger'
import ErrorPage from '../../../pages/errorPage/ErrorPage'

class ErrorBoundary extends React.Component<React.PropsWithChildren<unknown>, { hasError: boolean }> {
  public state = { hasError: false }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true })
    // the logger name is also used in CLB backend to configure the opsgenie alerting!
    getLogger('ErrorPage').error('error page shown', {
      error,
      errorInfo,
    })
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorPage />
    }

    return this.props.children
  }
}

export default ErrorBoundary
